import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sgBadgeLimit',
  standalone: false,
})
export class SgBadgeLimit implements PipeTransform {
  transform(value: string | number, limit: number = 99, emptyIfZero: boolean = false) {
    const num = Number(value);
    if (emptyIfZero && num === 0) {
      return '';
    }

    if (num > limit) {
      return `${limit}+`;
    }
    return value;
  }
}
